<template>
    <f7-page
        name="My Activity"
        class="onboardingBg"
    >
        <f7-navbar
            inner
            large
            title-large="My Activity"
            no-hairline
            large-transparent
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>My Activity</f7-nav-title>
            <f7-nav-right />
        </f7-navbar>
        <f7-list v-if="myEvents.length === 0 && isLoaded">
            <f7-list-item :title="'None yet'" />
        </f7-list>
        <f7-list
            v-else
            media-list
        >

            <sequential-entrance from-bottom>
                <template v-for="(event, index) in myEvents">
                    <event-card
                        :event="event"
                        :key="`event-${index}`"
                        :home="true"
                        :in-card="true"
                    />
                </template>
            </sequential-entrance>

        </f7-list>
    </f7-page>
</template>

<script>
import EventCard from '../components/eventCard.vue';

export default {
    store: ['api', 'myEvents', 'unreadEvents'],
    components: {
        EventCard
    },
    data () {
        return {
            isLoaded: false
        };
    },
    created: function () {
        this.getEvents();
    },
    mounted: function () { },
    methods: {
        renderEventTitle: function (event, isSubtitle) {
            let text = '';
            let subtitle = '';
            if (event.name === 'day_complete') {
                text = `Completed day ${event.itemId + 1}`;
            }
            if (event.name === 'comment_like' && event.comment) {
                text = `@${event.fromUser.username} ${event.comment.parentId ? 'liked' : 'upvoted'} your comment`;
                subtitle = event.comment.text;
            }
            if (event.name === 'comment_reply') {
                text = `@${event.fromUser.username} replied to your comment`;
                subtitle = event.comment.text;
            }
            if (event.name === 'comment_mention') {
                text = `@${event.fromUser.username} mentioned you in a comment`;
                subtitle = event.comment.text;
            }
            if (isSubtitle) return subtitle;
            return text;
        },
        renderEventLink: function (event) {
            if (event.name === 'comment_like') {
                if (event.comment.parentId) return `/replies/${event.comment.parentId}`;
                else return `/units/${event.comment.unitId}/comments`;
            }
            if (event.name === 'comment_reply') {
                return `/units/${event.comment.unitId}/comments`;
            }
            if (event.name === 'comment_mention') {
                return `/comments/${event.comment.unitId}`;
            }
            return false;
        },
        getEvents: function (loadMore) {
            this.$http.get(`${this.api}/events?read=1&offset=0`).then(
                response => {
                    let myEvents = response.body;
                    this.isLoaded = true;
                    for (let i = 0; i < myEvents.length; i++) {
                        const event = myEvents[i];
                        event.title = this.renderEventTitle(event);
                        event.subtitle = this.renderEventTitle(event, true);
                        event.link = this.renderEventLink(event);
                    }
                    if (loadMore) {
                        this.myEvents.push(myEvents);
                    } else {
                        this.myEvents = myEvents;
                    }
                    this.unreadEvents = 0;
                },
                () => {
                    console.error('Could not fetch events');
                }
            );
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
</style>
